import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_EDD_DATE_REQUEST: '',
  GET_EDD_DATE_SUCCESS: '',
  GET_EDD_DATE_FAILURE: '',

  SAVE_EDD_DATE_REQUEST: '',
  SAVE_EDD_DATE_SUCCESS: '',
  SAVE_EDD_DATE_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityEDD');

export default types;
